// Reveal-by-button behavior removed: content is now shown by default.

const sliderImages = document.querySelector(".gpsr-images");
const images = document.querySelectorAll(".gpsr-images img");
const prevButton = document.querySelector("button.gpsr-slider-prev");
const nextButton = document.querySelector("button.gpsr-slider-next");

let currentIndex = 0;

// Event listeners for buttons
prevButton?.addEventListener("click", () => {
  changeSlide(-1);
});

nextButton?.addEventListener("click", () => {
  changeSlide(1);
});

function changeSlide(direction) {
  currentIndex += direction;

  // Loop back to the end/start when exceeding bounds
  if (currentIndex < 0) {
    currentIndex = images.length - 1;
  } else if (currentIndex >= images.length) {
    currentIndex = 0;
  }

  // Move slider
  const offset = -currentIndex * 100;
  if (sliderImages) {
    sliderImages.style.transform = `translateX(${offset}%)`;
  }
}